export const enum SettingsTabs {
  USER = 'Users',
  DROPDOWN_LISTS = 'Dropdown Lists',
}
